<template>
  <div class="wrap categoryList">
    <div class="header">
      <NavBar
        :title= title
        left-arrow
        @click-left="$router.go(-1)"
        class="no_bg"
      ></NavBar>
    </div>
    <div class="main">
      <div class="listBox" >
        <div class="listScroll">
          <div>
            <div v-for="(item,index) in list" :key="index">
              <van-image :src="toPicProductImg(item)" fit="cover" />
            </div>
          </div>
        </div>
      </div>
    </div>
  
  </div>
</template>
<script>
import request from "../../api/request";
import { toPicProductImg } from "../../utils/common";
export default {
  data() {
    return {
      title:'',
      list:[]
    }
  },
  mounted() {
    this.getItem()
  },
  methods:{
    toPicProductImg,
    getItem() {
      let data = { productId : this.$route.query.productId};
      request("get", `cms/product/getById/${this.$route.query.productId}`).then(res => {
        if (res.code === 200) {
          this.list = res.data.productFileEntity.detailImg.split(",");
        }
      });
    },
    toElseDetal(item){
      this.$router.push({
        path: "/productItem",
        query: {
          id: item.productId
        }
      });
    },
  }
}
</script>

<style lang="less" scoped>
  .listBox {
    overflow: hidden;
    .listBoxTitle {
      font-size: 15px;
      font-weight: bold;
      padding: 0 0 10px 10px;
      text-align: left;
    }
    .listScroll {
      // width: 100%;
      display: flex;
      overflow: scroll;
      margin-bottom: 20px;
      margin-top: 10px;
      padding: 0 20px;
      flex-wrap: wrap;
      justify-content: space-between;
    }
    
      .imgBox2 .van-image {
        width: 144px;
        height: 144px;
        img {
          width: 100%;
          max-height: 100%;
        }
      }
    
  }
</style>